export const X_URL = "https://x.com/pupoweenwifhaf";
export const TG_URL = "https://t.me/POWEENGROUP";
export const CA_PLACEHOLDER = "HqNWAzhZDV5J5DXYv7P3Hof8NH2gu3r7EAwYNc8Xpump";

export const DOG_IMG =
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_1209b340-0b9d-45af-8029-8cc55a58bff4/artifacts/8ed07eac1104ef57_16d78c49-46cc-4cbd-8a8a-8341513f1d37.png";
export const BANNER_IMG =
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_1209b340-0b9d-45af-8029-8cc55a58bff4/artifacts/dbf830692f3e57a2_0DAF3862-7BE0-46AA-A37B-7C8649653F74.JPG";

